import api from "shared/infra/services/api";
import { User } from "shared/providers/context/types/auth-context";

import { captureException, captureMessage } from "@sentry/nextjs";

import { TClassName } from "./index.d";
import { getEntityType } from "./utils";

export const fetchPixelRequest = async (
  className: TClassName,
  slug: string,
  promoterLink?: string,
) => {
  if (!slug || !className) return [];

  const entityType = getEntityType(className);

  const routeToRequest = !!promoterLink
    ? `pixel/${entityType}/${slug}/${promoterLink}`
    : `pixel/${entityType}/${slug}`;

  try {
    const response = await api.get(routeToRequest);

    return response?.data?.data;
  } catch (error) {
    console.log("Erro (fetchPixelRequest): ", error);
    captureException(error);
    captureMessage("Erro (fetchPixelRequest)");
    return [];
  }
};

export const dispatchAPITrack = async (
  event_name: string,
  event_id: string,
  pixel_id: number,
  loggedUser: User,
  payload,
) => {
  const requestPayload = {
    event_id,
    pixel_id,
    event_name,
    content_id: payload?.productId,
    content_type: payload?.className,
    content_name: payload?.productName,
    fbc: payload?.fbc,
    fbp: payload?.fbp,
  };

  if (loggedUser) {
    const userFields = ["first_name", "last_name", "email"];

    userFields.forEach((field) => {
      requestPayload[field] = loggedUser[field];
    });

    if (!!loggedUser?.addresses?.length) {
      const addressFields = ["zip_code", "city", "state", "country"];
      const address = loggedUser?.addresses?.at(0);

      addressFields.forEach((field) => {
        requestPayload[field] = address[field?.replace("_", "")];
      });
    }

    if (!!loggedUser?.phones?.length) {
      const phone = loggedUser?.phones?.at(0);

      requestPayload["phone"] = phone?.full_number;
    }
  }

  if (payload?.value) requestPayload["value"] = payload?.value;
  if (payload?.currency) requestPayload["currency"] = payload?.currency;
  if (payload?.offer_name) requestPayload["offer_name"] = payload?.offer_name;
  if (payload?.promoterLink)
    requestPayload["promoter_link"] = payload?.promoterLink;

  try {
    const response = await api.post("/pixel-facebook", requestPayload);

    return response;
  } catch (error) {
    console.log(error);

    const response = error?.response;

    return response;
  }
};
